import React, { useState } from "react"
import { useTranslation } from "react-i18next"
import ApiConnectorCard from "../ApiConnectorCard"
import EasyVistaConfigModal from "./EasyVistaConfigModal"
import easyvistaLogo from "assets/images/connectors/easyvista-logo.png"

/**
 * EasyVista card for the developer portal
 * Allows configuring a centralized EasyVista connection for the entire platform
 */
const EasyVistaCard = () => {
  const { t } = useTranslation()
  const [isModalOpen, setIsModalOpen] = useState(false)

  // TODO: Fetch the actual connection status from the API
  const [connectionStatus, setConnectionStatus] = useState("configure_now")

  const handleConfigure = () => {
    setIsModalOpen(true)
  }

  const handleCloseModal = () => {
    setIsModalOpen(false)
  }

  const handleSaveConfig = async (config) => {
    // TODO: Implement centralized configuration save
    console.log("EasyVista config saved:", config)
    setConnectionStatus("connected")
    setIsModalOpen(false)
  }

  return (
    <>
      <ApiConnectorCard
        serviceName={t("developer_portal:connectors.easyvista.name")}
        description={t("developer_portal:connectors.easyvista.description")}
        tag={t("developer_portal:connectors.easyvista.tag")}
        status={connectionStatus}
        // TODO: temporary desactivate
        // onStatusClick={handleConfigure}
        logoSource={easyvistaLogo}
        logoAlt="EasyVista"
        fillIcon={true}
      />
      <EasyVistaConfigModal
        isOpen={isModalOpen}
        onClose={handleCloseModal}
        onSave={handleSaveConfig}
      />
    </>
  )
}

export default EasyVistaCard
